import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent, onMounted, reactive, ref, watch } from "vue";
import { useState } from "@/hooks/mapGet/index.js";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { changeTag } from "@/hooks/tagCate";
import PlayListHead from "@/components/play-list-head/play-list-head.vue";
import PlayList from "@/components/play-list/playList.vue";
import Loading from "@/baseui/loading/loading.vue";
import Pagination from "@/baseui/pagination/pagination.vue";
export default defineComponent({
  name: "Playlist",
  setup: function setup() {
    var route = useRoute();
    var state = useState("PlayList", ["tagList", "playList", "total"]);
    var store = useStore();
    var listHead = ref();
    var isShow = ref(false); //显示隐藏加载中

    var listTag = ref(["华语", "流行", "摇滚", "民谣", "电子", "另类/独立", "轻音乐", "综艺", "影视原声", "ACG"]);
    var pageInfo = reactive({
      cat: "",
      limit: 50,
      offset: 1
    });
    var curtPage = ref(1);
    /* 如果传递过来路由标签数据 */

    if (route.query.tag) {
      /* 则加载传递的数据 */
      var mounted = onMounted(function () {
        var _listHead$value;

        (_listHead$value = listHead.value) === null || _listHead$value === void 0 ? void 0 : _listHead$value.tagClick(route.query.tag);
      });
    } else {
      /* 否则默认加载全部视频 */
      store.dispatch("PlayList/getPlayList", pageInfo);
    }

    store.dispatch("PlayList/getPlayListTag");
    /* 标签改变切换标签数据*/

    var changeTagName = function changeTagName(tag, page) {
      if (!page) {
        curtPage.value = 1;
        pageInfo.offset = 1;
      }

      pageInfo.cat = tag; //请求防抖

      isShow.value = changeTag(function () {
        return store.dispatch("PlayList/getPlayList", pageInfo);
      }, page || tag, 700);
    };
    /* 页数改变事件 */


    var changeCurrent = function changeCurrent(page) {
      curtPage.value = page;
      pageInfo.offset = (page - 1) * pageInfo.limit;
      changeTagName(pageInfo.cat, page);
    };
    /* 监听歌单数据改变 */


    watch(state.playList, function () {
      isShow.value = true;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listHead: listHead,
      listTag: listTag,
      isShow: isShow,
      curtPage: curtPage,
      pageInfo: pageInfo,
      changeTagName: changeTagName,
      changeCurrent: changeCurrent
    });
  },
  components: {
    PlayListHead: PlayListHead,
    PlayList: PlayList,
    Loading: Loading,
    Pagination: Pagination
  }
});